import React from "react";
import { Route, type RouteProps } from "react-router-dom";
import { useAccessible } from "src/authentication/hooks/useAccessible";
import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export interface IAccessRightRouteProps extends RouteProps {
  rights: AuthenticationAccessRight;
  except?: AuthenticationAccessRight;
}

/**
 * @deprecated
 */
export default (props: IAccessRightRouteProps) => {
  const { rights, except, ...rest } = props;
  const canAccess = useAccessible(rights, except);

  if (!canAccess) {
    return null;
  }

  return <Route {...rest} />;
};
